<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fill="currentColor"
      d="M3.334 14.667h8.487a2 2 0 0 0 1.966-1.64l.847-4.667A2 2 0 0 0 12.667 6h-3.04l.374-.953a2.753 2.753 0 0 0-2.594-3.714.667.667 0 0 0-.606.394L4.9 6H3.334a2 2 0 0 0-2 2v4.667a2 2 0 0 0 2 2Zm2.667-7.86 1.813-4.08a1.42 1.42 0 0 1 .92 1.853l-.353.953a1.333 1.333 0 0 0 1.246 1.8h3.04a.667.667 0 0 1 .514.24.668.668 0 0 1 .153.547l-.847 4.667a.666.666 0 0 1-.666.546H6V6.807ZM2.667 8a.667.667 0 0 1 .667-.667h1.333v6H3.334a.667.667 0 0 1-.667-.666V8Z"
    />
  </svg>
</template>
